var _defs, _image, _path, _path2, _line, _path3, _g, _line2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComprobanteGen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 121 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.45;}.cls-2{fill:#fff;}.cls-3{fill:none;stroke:#898b8d;stroke-linecap:round;stroke-width:2px;}.cls-10,.cls-4,.cls-5{isolation:isolate;}.cls-10,.cls-5{font-size:12px;fill:#464646;font-family:Barlow-SemiBold, Barlow;font-weight:600;}.cls-5{letter-spacing:0.03em;}.cls-10,.cls-6{letter-spacing:0.03em;}.cls-7{letter-spacing:0.02em;}.cls-8{letter-spacing:0.02em;}.cls-9{letter-spacing:0.03em;}.cls-11{fill:#f92d71;}"))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    className: "cls-1",
    width: 121,
    height: 133,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAACFCAYAAAB/qlcrAAAACXBIWXMAAAsSAAALEgHS3X78AAAEUUlEQVR4Xu3Yy3IaRxiG4RckrEOsSiXOwuVkk7uZS57bSSVR4liSJXRA4qDOovuHnhFWvDGHfN9b1QUMA5uH7ulhkFJiXW3bDta+4XaypmnWQwKDPnLBDeD6udvNUvWY4CX4ErmaucM1A4y9iwXsc2+kGvqw96FhOTaqxiGG3sVq3Fk15sCibdvljB6klGIWB/ARcAp8V8YRK2gj70YxgxfAFJgAD8B9eT4r76WmaVLM5EAekYF/BN6VxzMy9AG+Ru9CsQzHDH4AxsAlcFWdEz8CDnvX4hHwFvgJ+AX4QIY+Le/Fsu22WyzVT8AtcAGckCdgLNuLcs6rM/kD8Cvwnjyb3+Ale1eKWfoI3ADn5fiEjH5PXsYHbdsO+shxTX5Lhn4P/Ax8Dxxj5F0pkCfAdTk2Bj6RnTqr7pd217H5OiMD/0D3uuy2WyAfl9djstUJecXt7J9q5Dg4LCeNygeOyjjGyLvSclNFXrKPyVYj1myQ+zMZVtA1eD2MvP1ih923CbeO0TrkaPDKcNvvq318SySQkQUyskBGFsjIAhlZICMLZGSBjCyQkQUyskBGFsjIAhlZICMLZGSBjCyQkQUyskBGFsjIAhlZICMLZGSBjCyQkQUyskBGFsjIAhlZICMLZGSBjCyQkQUyskBGFsjIAhlZICMLZGSBjCyQkQUyskBGFsjIAhlZICMLZGSBjCyQkQUyskBGFsjIAhlZICMLZGSBjCyQkQUyskBGFsjIAhlZICMLZGSBjCyQkQUyskBGFsjIAhlZICMLZGSBjCyQkQUyskBGFsjIAhlZICMLZGSBjCyQkQUyskBGFsjIAhlZICMLZGSBjCyQkQUyskBGFsjIAhlZICMLZGSBjCyQkQUyskBGFsjIAhlZICP/P0rVeJGR97sEPNNFjtfLjLy/1ajzMhZ00QEj72s17hR4qsacHrSR968AXgAzYALcA3fAA11owMj7Vg08JaPeAtfADRn6kYycgNQ0TTr8whe9Ntx2qoGfyMA3wCVwUR5vyDN7RrUB6yPXF/PFmgEwwG26dTP4M/AJ+FjGJTBmNZOXy3WNHMCx1k/LBybAcTnnACNvunCZk11iBl8AfwC/A3+Rke/Is3xBWaphhVwDT8mwt+XLrss5jxh5Gz2XEcC3ZNCPZODfyMhX5A1YZ6mG7kyOL3pk9Us5L++NybPZyJuvvg7fkSfdBRn5HPi7PB+z2lkvZzHAYdM0qW3bWPNn5F/DFfBnOWcMnAFH5N24kTdb3A8Hcmy2YsP1mWz0QF6FX/zjVS/XNfJlOTYB/gFOgRGrWy5Df/sCat0t07iMO7LXU3m/cy2O+sv1nAwLGfwWOAHesFqqDby56rudmM2xGX4sr2dU/3L1gQEGKeVjbdsG4AEZf1SNIV6qt1UfOnbZL/6rXgcMFTJ0oIe94Rm83Wro5+r5q7hRBxmW0NCFNfD2S9VjAvgv3OgFcl0F7nakr4Wt+xdtH4iyFZwCKAAAAABJRU5ErkJggg=="
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.92,11.4h93.85c.24,0,4.33,0,5,.06,4.37.33,4.27.45,4.27,5.31V122.15a9.23,9.23,0,0,1-9.23,9.23H14.92c-5.09,0-5.37-.28-5.37-5.38V16.77C9.55,11.67,9.83,11.4,14.92,11.4Z",
    transform: "translate(-3.55 -5.17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.36,64.07H68.59",
    transform: "translate(-3.55 -5.17)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.59,
    y1: 69.26,
    x2: 72.62,
    y2: 69.26
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.36,87.14H88.08",
    transform: "translate(-3.55 -5.17)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(22.88 23.39)"
  }, "C", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 7.62,
    y: 0
  }, "omp"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 32,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 36.73,
    y: 0
  }, "oban"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 64.25,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 68.95,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(26.75 37.39)"
  }, "de domicilio"))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.59,
    y1: 49.05,
    x2: 84.53,
    y2: 49.05
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 19.33,
    y: 103.87,
    width: 4.47,
    height: 4.47
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 25.8,
    y: 103.87,
    width: 4.47,
    height: 4.47
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 25.8,
    y: 110.97,
    width: 4.47,
    height: 4.47
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.11,
    y: 104.64,
    width: 2.91,
    height: 2.91
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.58,
    y: 104.48,
    width: 2.91,
    height: 2.91
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.58,
    y: 111.74,
    width: 2.91,
    height: 2.91
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 20.52,
    y: 105.05,
    width: 2.09,
    height: 2.09
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 26.99,
    y: 104.89,
    width: 2.09,
    height: 2.09
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 26.99,
    y: 112.15,
    width: 2.09,
    height: 2.09
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 19.33,
    y: 110.97,
    width: 4.47,
    height: 4.47
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.11,
    y: 111.74,
    width: 2.91,
    height: 2.91
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 20.52,
    y: 112.15,
    width: 2.09,
    height: 2.09
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M122.05,111.45c.11,2-1.32,4.37-4.17,9.1-3.67,6.06-5.54,9.09-7.43,9.09-2.12,0-4-3.18-7.67-9.56-2.41-4.13-3.61-6.23-3.56-8.08.14-4.76,4.8-10.81,11.42-10.82C117,101.17,121.78,106.78,122.05,111.45Z",
    transform: "translate(-3.55 -5.17)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 107.09,
    cy: 106.11,
    r: 4.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprobanteGen);
export default __webpack_public_path__ + "static/media/ComprobanteGen.0966833f4a794307e503f46b10ec5daa.svg";
export { ForwardRef as ReactComponent };